import Vue from 'vue';
import Vuex from 'vuex';

import user from '@/store/modules/user';
import promotion from '@/store/modules/promotion';

Vue.use(Vuex);

/**
 * Export Vuex store with strict mode and
 * middleware depending on config.ENV.debug setting for current environment
 *
 * @type {Vuex}
 */
export const store = new Vuex.Store({
    modules: {
        user,
        promotion,
    },

    state: {
        preloaderAxiosRequestScreen: false,
    },

    getters: {

    },

    mutations: {

    },

    actions: {

    },

    strict: false,
});
